import React from "react";
import PropTypes from "prop-types";
import { Grid, TextField } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import PopoverButton from "../PopoverButton/PopoverButton";

const styles = (theme) => ({
  colorUnderline: {
    borderBottom: `1px solid #0091ff`,
    background: "white",

    "&:before": {
      borderBottom: `1px solid #0091ff`,
    },
    "&:after": {
      borderBottom: `1px solid #0091ff`,
    },
  },
  date: {
    color: "gray",
    fontSize: 12,
  },
  border: {
    border: "1px solid #F6F6F9",
    borderRadius: 10,
    background: "#F6F6F9",
    padding: 13,
    marginBottom: 20,
  },
  textBackground: {
    background: "white",
  },
});
const CommentBox = (props) => {
  const handleChange = (event) => {
    props.setOveralComment(event.target.value);
  };
  const { classes, overalComment, notes, type } = props;

  return (
    <Grid container>
      <Grid item xs={12} sm={8}>
        <div
          className={classes.shadow}
          dangerouslySetInnerHTML={{
            __html: notes,
          }}
        ></div>
      </Grid>
      <Grid item xs={12} sm={4} justifyContent="end" sx={{ textAlign: "end" }}>
        <PopoverButton type={type} />
      </Grid>
    </Grid>
  );
};

CommentBox.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(CommentBox);
